import { getAxiosInstance } from '../../configs/axios-config';
import { authDetails } from '../../helpers/auth-details';
var constants = require("../../configs/constants");

const ADD_ABOUTUS_PROGRESS = "ADD_ABOUTUS_PROGRESS";
const ADD_ABOUTUS_SUCCESS = "ADD_ABOUTUS_SUCCESS";
const ADD_ABOUTUS_FAILURE = "ADD_ABOUTUS_FAILURE";
const GET_ABOUTUS_PROGRESS = "GET_ABOUTUS_PROGRESS";
const GET_ABOUTUS_SUCCESS = "GET_ABOUTUS_SUCCESS";
const GET_ABOUTUS_FAILURE = "GET_ABOUTUS_FAILURE";
const LOADING_ABOUT_IN_PROGRESS = "LOADING_ABOUT_IN_PROGRESS";
const ABOUTUS_PHOTO_SUCCESS = "ABOUTUS_PHOTO_SUCCESS";
const SEND_CASE = "SEND_CASE";
const DELETE_ABOUTUS_MODAL = "DELETE_ABOUTUS_MODAL";
const DELETE_DATA_SUCCESS = "DELETE_DATA_SUCCESS";
const DELETE_DATA_FAILURE = "DELETE_DATA_FAILURE";
const HIDE_ABOUT_SNACKBAR = "HIDE_ABOUT_SNACKBAR";

export const hideSnackBarAction = () => { return { type: HIDE_ABOUT_SNACKBAR } }
export const loadingInProgress = () => { return { type: LOADING_ABOUT_IN_PROGRESS } }
export const getAboutUsInProgress = () => { return { type: GET_ABOUTUS_PROGRESS } }
export const getAboutUsSuccess = (aboutUsData) => { return { type: GET_ABOUTUS_SUCCESS, aboutUsData: aboutUsData } }
export const getAboutUsFailure = (errorMessage) => { return { type: GET_ABOUTUS_FAILURE, message: errorMessage } }
export const addAboutUsInProgress = (aboutUsData) => { return { type: ADD_ABOUTUS_PROGRESS, aboutUsData: aboutUsData } }
export const addAboutUsSuccess = (successMessage) => { return { type: ADD_ABOUTUS_SUCCESS, message: successMessage } }
export const addAboutUsFailure = (errorMessage) => { return { type: ADD_ABOUTUS_FAILURE, message: errorMessage } }
export const editAboutUsSuccess = (successMessage) => { return { type: ADD_ABOUTUS_SUCCESS, message: successMessage } }
export const editAboutUsFailure = (errorMessage) => { return { type: ADD_ABOUTUS_FAILURE, message: errorMessage } }
export const returnSwitch = (caseData, edit, aboutData) => { return { type: SEND_CASE, caseData: caseData, edit: edit, aboutData: aboutData } }
export const addPhotoSuccess = (photoUrl, successMsg) => { return { type: ABOUTUS_PHOTO_SUCCESS, photoUrl: photoUrl, successMsg: successMsg } }
export const deleteAboutDataSuccess = (successMsg) => { return { type: DELETE_DATA_SUCCESS, message: successMsg } }
export const deleteAboutDataFailure = (errorMsg) => { return { type: DELETE_DATA_FAILURE, message: errorMsg } }
export const returnDeleteModal = (deleteCase, deletedId) => { return { type: DELETE_ABOUTUS_MODAL, deleteCase: deleteCase, deletedId: deletedId } }

/**
* render the delete user modal 
* @param {boolen & object}, true, delete user id
*/
export const showDeleteModal = (deleteCase, deletedId) => (dispatch) => {
    dispatch(returnDeleteModal(deleteCase, deletedId));
};

/**
 * Render the component using switch case
 * @param {String,boolean,object}, aboutData(object)
 */
export const renderSwitch = (caseData, edit, aboutData) => (dispatch) => {
    dispatch(returnSwitch(caseData, edit, aboutData));
};

// HIDE THE MESSAGE SNACKBAR
export const hideSnackBar = () => (dispatch) => {
    dispatch(hideSnackBarAction());
}

// upload the image 
export const uploadFile = (image) => (dispatch) => {
    dispatch(loadingInProgress());
    let bodyFormData = new FormData();
    bodyFormData.append('file', image.documentImage);
    const config = {
        headers: { 'content-type': 'multipart/form-data' }
    }

    let axiosInstance = getAxiosInstance();
    return axiosInstance.post(constants.api.UPLOAD, bodyFormData, config
    ).then(function (response) {
        dispatch(addPhotoSuccess(response.data.secureUrl, "फोटो यशस्वीरित्या अपलोड केला आहे"));
    }).catch(function (error) {
        dispatch(addAboutUsFailure(error.message));
    });
};

/**
 *  SOCIETY GET YEARLY REPORTS
 * @param, year
 */
export const getAboutUs = (data) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    dispatch(getAboutUsInProgress());
    return axiosInstance.get(constants.api.GET_ABOUTUS + user._id + '/' + data.perpage + '/' + data.page)
        .then(function (response) {
            dispatch(getAboutUsSuccess(response.data));
        }).catch(function (error) {
            dispatch(getAboutUsFailure(error.message));
        });
};

/**
 * Save the aboutUs Details
 * @param {object}
 */
export const addAboutUs = (aboutUsData) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    dispatch(addAboutUsInProgress(aboutUsData));
    return axiosInstance.post(constants.api.POST_ABOUT_US, {
        titleName: aboutUsData.allData.titleName,
        documentImage: aboutUsData.documentImage,
        description: aboutUsData.allData.description,
        addedBy: user._id,
        societyId: user._id
    }).then(function (response) {
        dispatch(addAboutUsSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(addAboutUsFailure(error.response.data.message));
    });
};

/**
 * Edit the aboutUs Details
 * @param {object}
 */
export const editAboutUs = (aboutUsData) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();
    dispatch(addAboutUsInProgress(aboutUsData));
    return axiosInstance.put(constants.api.POST_ABOUT_US, {
        titleName: aboutUsData.titleName,
        documentImage: aboutUsData.documentImage,
        description: aboutUsData.description,
        aboutUsId: aboutUsData.aboutUsId,
        addedBy: user._id,
        societyId: user._id
    }).then(function (response) {
        dispatch(editAboutUsSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(editAboutUsFailure(error.response.data.message));
    });
};

// delete about us by id
export const deleteAboutUs = (userId) => (dispatch) => {
    let axiosInstance = getAxiosInstance();
    return axiosInstance.patch(constants.api.DELETE_ABOUT_US + userId).then(function (response) {
        dispatch(deleteAboutDataSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(deleteAboutDataFailure(error.message));
    });
}

export const initialState = {
    inProgress: false,
    message: '',
    open: false,
    choice: 'table',
    aboutUsData: [],
    aboutData: '',
    photoUrl: null,
    add: false,
    delete: false,
    edit: false,
    deletedId: '',
    deleteCase: false,
    loading: false,
    totalRowsCount: 0
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ABOUTUS_PROGRESS:
            return { ...state };
        case GET_ABOUTUS_SUCCESS:
            return { ...state, aboutUsData: action.aboutUsData.dataList, totalRowsCount: action.aboutUsData.totalItems };
        case GET_ABOUTUS_FAILURE:
            return { ...state, message: action.message, inProgress: false, };
        case ADD_ABOUTUS_PROGRESS:
            return { ...state, inProgress: true };
        case ADD_ABOUTUS_SUCCESS:
            return { ...state, message: action.message, inProgress: false, open: true, choice: 'table', add: true, photoUrl: null };
        case ADD_ABOUTUS_FAILURE:
            return { ...state, message: action.message, inProgress: false, open: true };
        case DELETE_ABOUTUS_MODAL:
            return { ...state, deletedId: action.deletedId, deleteCase: action.deleteCase, delete: true };
        case DELETE_DATA_SUCCESS:
            return { ...state, message: action.message, open: true, deleteCase: false };
        case DELETE_DATA_FAILURE:
            return { ...state, message: action.message, open: true };
        case LOADING_ABOUT_IN_PROGRESS:
            return { ...state, loading: true };
        case ABOUTUS_PHOTO_SUCCESS:
            return { ...state, photoUrl: action.photoUrl, message: action.successMsg, open: true, loading: false };
        case SEND_CASE:
            return { ...state, choice: action.caseData, edit: action.edit, aboutData: action.aboutData };
        case HIDE_ABOUT_SNACKBAR:
            return { ...state, open: false };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/society/about-reducer.js